// src/i18n/index.js - Configuration principale d'i18next
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import des traductions
import frTranslations from '../CP-Public/Public-fr.json';
import enTranslations from '../CP-Public/Public-en.json';
import esTranslations from '../CP-Public/Public-es.json';
import arTranslations from '../CP-Public/Public-ar.json';

const resources = {
  fr: {
    translation: frTranslations
  },
  en: {
    translation: enTranslations
  },
  es: {
    translation: esTranslations
  },
  ar: {
    translation: arTranslations
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    debug: process.env.NODE_ENV === 'development',
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'aladinn_language'
    },

    interpolation: {
      escapeValue: false // React échappe déjà les valeurs
    },

    // Configuration pour les langues RTL
    react: {
      useSuspense: false
    }
  });

export default i18n;